import { observer } from 'mobx-react';
import React, { SyntheticEvent, useEffect, useRef, useState } from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import toast from 'react-hot-toast';
import { FormattedMessage } from 'react-intl';
import SlidingPanel from 'react-sliding-side-panel';
import noMessageIcon from '../../assets/Images/no-factory-schedule.png';
import { ModuleType } from '../../constants/enums/module-type-enum';
import WeekdaysEnum from '../../constants/enums/weekend-enum';
import { useStore } from '../../contexts/store-provider';
import { AddEditHolidayInitialState } from '../../core/initialState';
import {
  isOperationPermittedRoleBase,
  showIconsRoleBase,
} from '../../helpers/action-permission-helper';
import { getTenantIdFromLocalStorage } from '../../helpers/localstorage-helper';
import IPageInfo, {
  IActionFormatter,
  IPageLimitInfo,
} from '../../models/ICommon';
import { IAddHoliday } from '../../models/forms/IAddEditHoliday';
import { IHolidayVM } from '../../models/response/IHolidayResponse';
import FormLoader from '../../shared-components/FormLoader/FormLoader';
import Grid from '../../shared-components/Grid/Grid';
import { CustomActionFormatter } from '../../shared-components/Grid/GridFormatter';
import Header from '../../shared-components/header/header';
import FilterPopupHOC from '../../shared-components/hoc/filter-popup-hoc/filter-popup-hoc';
import DeletePopup from '../../shared-components/popup/delete/delete-popup';
import DeletePopupHOC from '../../shared-components/popup/delete/delete-popup-hoc';
import {
  CloseSidePanelIcon,
  DeleteIcon,
  ExportHolidayIcon,
  HolidayCalendarViewIcon,
  HolidayNextYearIcon,
  HolidayPreviousYearIcon,
  HolidayTabularViewIcon,
  ImportHolidayIcon,
  RefreshIcon,
} from '../../shared-components/svgs/svgs';
import { formatMessage } from '../../translations/format-message';
import AddEditHolidaySchedule from './components/add-holiday-calendar';
import AddEditWeekend from './components/add-weekend';
import CalendarView from './components/calendar-view';
import ImportHolidays from './components/import-holidays';
import FactoryScheduleDetails from './factory-schedule-details';
import './factory-schedule.css';
import AddFactorySchedulePopupHOC from './hoc/add-factory-schedule-popup-hoc';
import AddHolidayCalendarPopupHOC from './hoc/add-holiday-calendar-popup-hoc';
import ImportHolidayPopupHOC from './hoc/add-import-holiday-popup-hoc';
import DeleteAllFactorySchedulePopupHOC from './hoc/delete-all-factory-schedule-popup-hoc';
import { HolidayCalendarIcon } from '../../shared-components/svgs/module-svgs';

const FactorySchedule = (props: any) => {
  const { preferencesStore, factoryScheduleStore } = useStore();
  const [year, setYear] = useState(new Date().getFullYear());
  const handlePreviousYear = () => {
    setYear(year - 1);
    closePanelHandler();
    setSelectedDate(new Date(year - 1, 0, 1));
  };
  const handleNextYear = () => {
    setYear(year + 1);
    closePanelHandler();
    setSelectedDate(new Date(year + 1, 0, 1));
  };

  const {
    userSetting,
    language,
    islanguageChanged,
    updateLanguageChangedFlag,
  } = preferencesStore;
  const {
    GetFactoryScheduleListService,
    allFactorySchedule,
    deleteFactoryScheduleState,
    DeleteFactoryScheduleService,
    resetDeleteFactoryScheduleState,
    addUpdateFactoryScheduleState,
    resetAddUpdateFactoryScheduleState,
    getFactoryScheduleByIdState,
    getAllFactoryScheduleState,
    resetFactoryScheduleDetail,
    AddFactoryWeekendService,
    addEditFactoryWeekendState,
    allFactoryWeekendSchedule,
    resetAddEditFactoryWeekendState,
    ExportFileService,
    exportFileState,
    resetExportFileState,
    base64String,
    fileUploadState,
    resetFileUploadState,
    calendarHolidays,
    weekendDays,
    DeleteAllFactoryScheduleService,
    deleteAllFactoryScheduleState,
    resetDeleteAllFactoryScheduleState,
  } = factoryScheduleStore;

  let lang: string;
  const allHolidayListData = allFactorySchedule;
  const [firstOff, setFirstOff] = useState(-1);
  const [secondOff, setSecondOff] = useState(-1);
  const [disablePagination, setDisablePagination] = useState<boolean>(false);
  const [selectedRow, setSelectedRow] = useState<any>({});
  const [selectedId, setSelectedId] = useState(0);
  const [openPanel, setOpenPanel] = useState(false);
  const [isFilterCleared, setIsFilterCleared] = useState(true);
  const [selectedDate, setSelectedDate] = useState<Date>(null);
  // Stable fallback for the Add Holiday form's date field until the operator picks a day on the
  // calendar - `new Date()` must not be recomputed on every render (e.g. from an unrelated click
  // elsewhere on the page), or Formik's enableReinitialize sees a "changed" HolidayDate prop and
  // wipes out whatever Name/Comment the operator had already typed.
  const defaultSelectedDateRef = useRef(new Date());
  const [filterObj, setFilterObj] = useState<IAddHoliday>(
    AddEditHolidayInitialState
  );
  const [toggleView, setToggleView] = useState(false);
  const [pageLimitInfo, setPageLimit] = useState<IPageLimitInfo>({
    pageLimit: userSetting.pageLimitConfig,
    isPageLimitChange: false,
  });

  const [pageInfo, setPageInfo] = useState<IPageInfo>({
    currentPage: 1,
    totalPages: 1,
    isPagerChange: false,
    isRefreshPage: false,
  });

  const getHolidayListServiceHandler = () => {
    GetFactoryScheduleListService(Number(getTenantIdFromLocalStorage()), year);
  };

  // useEffect(() => {
  //   getHolidayListServiceHandler();
  // }, []);

  useEffect(() => {
    getHolidayListServiceHandler();
  }, [year]);

  useEffect(() => {
    if (allFactoryWeekendSchedule && allFactoryWeekendSchedule.length > 0) {
      setFirstOff(WeekdaysEnum[allFactoryWeekendSchedule[0]?.Day]);
      setSecondOff(WeekdaysEnum[allFactoryWeekendSchedule[1]?.Day]);
    }
  }, [allFactoryWeekendSchedule]);

  useEffect(() => {
    if (fileUploadState.success) {
      toast.success(formatMessage('added_success'));
      resetFileUploadState();
      getHolidayListServiceHandler();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fileUploadState.success]);

  useEffect(() => {
    if (islanguageChanged) {
      updateLanguageChangedFlag();
    }
  }, [islanguageChanged]);

  useEffect(() => {
    if (pageInfo.isPagerChange) {
      getHolidayListServiceHandler();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageInfo.currentPage]);

  useEffect(() => {
    if (pageLimitInfo.isPageLimitChange) {
      getHolidayListServiceHandler();
      setPageLimit({ ...pageLimitInfo, isPageLimitChange: false });
    }
  }, [pageLimitInfo.pageLimit]);

  useEffect(() => {
    if (lang && language !== lang) {
      getHolidayListServiceHandler();
    }
  }, [language]);

  useEffect(() => {
    if (addUpdateFactoryScheduleState.success) {
      resetAddUpdateFactoryScheduleState();
      getHolidayListServiceHandler();
    }
    closePanelHandler();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addUpdateFactoryScheduleState.success]);

  useEffect(() => {
    if (deleteFactoryScheduleState.success) {
      toast.success(formatMessage('deleted_success'));
      props.deletePopupToggleHandler();
      resetDeleteFactoryScheduleState();
      getHolidayListServiceHandler();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteFactoryScheduleState.success]);

  useEffect(() => {
    if (deleteAllFactoryScheduleState.success) {
      toast.success(formatMessage('deleted_success'));
      props.deleteAllToggleHandler();
      resetDeleteAllFactoryScheduleState();
      getHolidayListServiceHandler();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteAllFactoryScheduleState.success]);

  function rowClassFormat(row: any, rowId: number) {
    let className: string = '';
    if (selectedRow?.Id && row.Id === selectedRow.Id) {
      className = 'bg-row SelectedRow';
    }
    return className;
  }

  useEffect(() => {
    if (addEditFactoryWeekendState.success) {
      toast.success(formatMessage('added_success'));
      resetAddEditFactoryWeekendState();
      getHolidayListServiceHandler();
    }
    closePanelHandler();
  }, [addEditFactoryWeekendState.success]);

  const rowEvents = (e: SyntheticEvent, row: any) => {
    setSelectedRow(row);
    if (
      selectedRow.HolidayId === undefined ||
      selectedRow.HolidayId !== row.HolidayId
    ) {
      setOpenPanel(true);
    } else {
      setOpenPanel(!openPanel);
    }
  };

  const closePanelHandler = () => {
    setSelectedRow({});
    setOpenPanel(false);
  };

  const refreshClickHandler = () => {
    getHolidayListServiceHandler();
    closePanelHandler();
  };

  const deleteHandler = () => {
    DeleteFactoryScheduleService(
      Number(getTenantIdFromLocalStorage()),
      selectedId,
      year
    );
  };

  const deleteAllHandler = () => {
    closePanelHandler();
    DeleteAllFactoryScheduleService(
      Number(getTenantIdFromLocalStorage()),
      year
    );
  };

  const deleteClickHandler = (
    row: IHolidayVM,
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    if (year < new Date().getFullYear()) return;
    setSelectedId(row.HolidayId);
    event.stopPropagation();
    closePanelHandler();
    resetFactoryScheduleDetail();
    props.deletePopupToggleHandler();
  };

  const calendarViewDeleteClickHandler = (
    holidayId: number,
    holidayYear: number
  ) => {
    if (holidayYear < new Date().getFullYear()) return;
    props.deletePopupToggleHandler();
    setSelectedId(holidayId);
    setYear(holidayYear);
  };

  const handleExport = (base64Data: string) => {
    // Decode the base64 string
    const binaryData = atob(base64Data);
    const binaryArray = new Uint8Array(binaryData.length);

    // Fill the binary array with the decoded binary data
    for (let i = 0; i < binaryData.length; i++) {
      binaryArray[i] = binaryData.charCodeAt(i);
    }

    // Create a Blob from the binary data with the MIME type for Excel
    const blob = new Blob([binaryArray], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });

    // Create a URL for the Blob and set up the download link
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `HolidaysExportFile-${Date.now()}.csv`;

    // Trigger the download by simulating a click on the link
    document.body.appendChild(link);
    link.click();

    // Clean up and remove the link after download
    document.body.removeChild(link);
    URL.revokeObjectURL(url);

    closePanelHandler();
    resetFactoryScheduleDetail();
  };

  useEffect(() => {
    if (exportFileState.success && base64String.fileString.length > 0) {
      handleExport(base64String.fileString);
      resetExportFileState();
    }
  }, [exportFileState.success]);

  useEffect(() => {
    const savedToggleState = localStorage.getItem('toggleView');
    setToggleView(savedToggleState !== null && savedToggleState === 'true');
  }, [toggleView]);

  const actionIcons: IActionFormatter[] = showIconsRoleBase(
    [
      {
        dataField: 'isDelete',
        handler: deleteClickHandler,
        icon: <DeleteIcon />,
        isDisable:
          !isOperationPermittedRoleBase(ModuleType.HolidayCalendar, 'Delete') ||
          year < new Date().getFullYear(),
        title: 'delete',
        varient: 'danger',
        action: 'delete',
      },
    ],
    ModuleType.HolidayCalendar
  );

  const columns: any = [
    {
      dataField: 'HolidayDate',
      text: formatMessage('factory_schedule_holiday_date'),
      classes: 'show-Elipses',
      // formatter: (cell) => {
      //   return cell && cell !== '-'
      //     ? convertNonUTCDateToLocalTimeZone(cell.toString())
      //     : '-';
      // },
      title: (cell: string) => {
        return cell && cell.length > 10 ? cell : undefined;
      },
    },
    {
      dataField: 'Day',
      text: formatMessage('factory_schedule_day'),
      classes: 'show-Elipses',
      title: (cell: string) => {
        return cell && cell.length > 10 ? cell : undefined;
      },
    },

    {
      dataField: 'HolidayName',
      text: formatMessage('factory_schedule_holiday_name'),
      classes: 'show-Elipses',
      title: (cell: string) => {
        return cell && cell.length > 10 ? cell : undefined;
      },
    },
    {
      dataField: 'Comment',
      text: formatMessage('factory_schedule_comment'),
      classes: 'show-Elipses',
      title: (cell: string) => {
        return cell && cell.length > 10 ? cell : undefined;
      },
    },
    {
      dataField: '',
      formatter: CustomActionFormatter(actionIcons),
      text: formatMessage('actions'),
      classes: 'last-column',
      hidden: actionIcons.length > 0 ? false : true,
    },
  ];

  const openImportFiletHandler = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    if (year < new Date().getFullYear()) return;
    event.stopPropagation();
    closePanelhandler();
    props.addToggleHandler();
    resetFactoryScheduleDetail();
  };

  const closePanelhandler = () => {
    setSelectedRow({});
    setOpenPanel(false);
  };

  const exportFiletHandler = () => {
    ExportFileService(Number(getTenantIdFromLocalStorage()), year);
  };

  return (
    <>
      {props.showImportPopup && (
        <ImportHolidays
          id={selectedId}
          modalClosed={props.addToggleHandler}
        />
      )}

      {props.showDeletePopup && (
        <DeletePopup
          title="delete_holiday"
          modalSubmit={deleteHandler}
          modalClosed={props.deletePopupToggleHandler}
          message="message_delete_holiday_confirm"
          isLoading={deleteFactoryScheduleState.inProgress}
        />
      )}

      {props.showDeleteAllPopup && (
        <DeletePopup
          title="delete_all"
          modalSubmit={deleteAllHandler}
          modalClosed={props.deleteAllToggleHandler}
          message="message_delete_all_holiday_confirm"
          isLoading={deleteAllFactoryScheduleState.inProgress}
        />
      )}

      <div className="icon-nav navbar-fixed-top device-nav-bar userTopNav">
        <div className="row align-items-center">
          <Header
            className="col-lg-4 col-md-5 col-sm-6"
            label="factory_schedule_title"
          />
          <div className="col-lg-8 col-md-7 col-sm-6">
            <ul className="add-list">
              {isOperationPermittedRoleBase(
                ModuleType.HolidayCalendar,
                'Add'
              ) && (
                <li
                  style={{
                    cursor: `${year < new Date().getFullYear() ? 'not-allowed' : ''}`,
                  }}
                  title={formatMessage('import')}
                >
                  <a
                    data-toggle="modal"
                    className={`btn btn-light ${year < new Date().getFullYear() ? 'disabled' : ''}`}
                    onClick={(event: any) => openImportFiletHandler(event)}
                  >
                    <ImportHolidayIcon />
                  </a>
                </li>
              )}
              {isOperationPermittedRoleBase(
                ModuleType.HolidayCalendar,
                'Add'
              ) && (
                <li
                  title={formatMessage('factory_schedule_export')}
                  className={`${allHolidayListData && allHolidayListData.length === 0 ? 'cursor-not-allowed' : ''}`}
                >
                  <a
                    data-toggle="modal"
                    className={`btn btn-light ${allHolidayListData && allHolidayListData.length === 0 ? 'disabled' : ''}`}
                    onClick={() => exportFiletHandler()}
                  >
                    <ExportHolidayIcon />
                  </a>
                </li>
              )}

              <li title={formatMessage('refresh')}>
                <a
                  data-toggle="modal"
                  className="btn btn-light"
                  onClick={() => refreshClickHandler()}
                >
                  <RefreshIcon />
                </a>
              </li>
              <ul className="tableAccordian-switch d-flex">
                <li
                  className={toggleView === false ? 'active' : ''}
                  onClick={() => {
                    localStorage.setItem('toggleView', JSON.stringify(false));
                    setToggleView((prev) => !prev);
                    getHolidayListServiceHandler();
                  }}
                >
                  <HolidayTabularViewIcon />
                  <span className="icon-text">
                    {formatMessage('tabular')}
                  </span>{' '}
                </li>
                <li
                  className={toggleView === true ? 'active' : ''}
                  onClick={() => {
                    localStorage.setItem('toggleView', JSON.stringify(true));
                    getHolidayListServiceHandler();
                    setToggleView((prev) => !prev);
                    closePanelHandler();
                    resetFactoryScheduleDetail();
                  }}
                >
                  <HolidayCalendarViewIcon />
                  <span className="icon-text">{formatMessage('calendar')}</span>
                </li>
              </ul>
              <li
                title={formatMessage('delete_all')}
                className={`${(allHolidayListData && allHolidayListData.length === 0) || year < new Date().getFullYear() ? 'cursor-not-allowed' : ''}`}
              >
                <a
                  className={`btn btn-secondary ${(allHolidayListData && allHolidayListData.length === 0) || year < new Date().getFullYear() ? 'disabled' : ''}`}
                  data-toggle="modal"
                  data-testid="modalbtn"
                  data-target="#addUser"
                  onClick={(event: any) => {
                    if (year >= new Date().getFullYear()) {
                      props.deleteAllToggleHandler();
                    }
                  }}
                >
                  <span className="deleteHoliday me-1">
                    <DeleteIcon />
                  </span>
                  <FormattedMessage id="delete_all" />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className={`${openPanel ? 'panelOpen' : ''}`}>
        <div className="card card-page overflow-hidden ">
          {(getAllFactoryScheduleState.inProgress ||
            getFactoryScheduleByIdState.inProgress ||
            deleteFactoryScheduleState.inProgress ||
            addEditFactoryWeekendState.inProgress) && (
            <FormLoader
              loading={
                getAllFactoryScheduleState.inProgress ||
                getFactoryScheduleByIdState.inProgress ||
                deleteFactoryScheduleState.inProgress ||
                addEditFactoryWeekendState.inProgress
              }
            />
          )}
          <div className="year-factory">
            <div className="row g-0">
              <div className="col-3 bg-light">
                <div className=" p-3">
                  <div className="mb-3">
                    <label className="form-label">
                      {formatMessage('select_year')}
                    </label>
                    {/* Year Start */}
                    <div className="year-selector-container form-control">
                      <button
                        className="year-selector-button"
                        onClick={handlePreviousYear}
                      >
                        <HolidayPreviousYearIcon />
                      </button>
                      <div className="year-selector-display">{year}</div>
                      <button
                        className="year-selector-button"
                        onClick={handleNextYear}
                      >
                        <HolidayNextYearIcon />{' '}
                      </button>
                    </div>
                  </div>
                  {year >= new Date().getFullYear() ? (
                    <Tabs
                      defaultActiveKey="AddHoliday"
                      id="holidays"
                      className="holidays_tab"
                    >
                      <Tab
                        eventKey="AddHoliday"
                        title={formatMessage('factory_schedule_add')}
                      >
                        <AddEditHolidaySchedule
                          id={-1}
                          selctedYear={year}
                          selectedDate={selectedDate || defaultSelectedDateRef.current}
                        />
                      </Tab>

                      <Tab
                        eventKey="AddWeekend"
                        title={formatMessage('add_weekoff')}
                      >
                        <AddEditWeekend selctedYear={year} />
                      </Tab>
                    </Tabs>
                  ) : (
                    <div>{formatMessage('no_add_remove_allowed')}</div>
                  )}
                </div>
              </div>
              <div className="col-9">
                <div>
                  {!toggleView ? (
                    <div>
                      {allHolidayListData && allHolidayListData.length > 0 ? (
                        <div className="tableDesign factoryTable row-eq-height tableDevices p-3 changingPanel">
                          <div
                            className="table-responsive"
                            data-testid="table"
                          >
                            {allHolidayListData && (
                              <Grid
                                data={allHolidayListData}
                                columns={columns}
                                keyField="HolidayId"
                                loading={false}
                                rowClasses={rowClassFormat}
                                rowEvents={{ onClick: rowEvents }}
                                hover={true}
                              />
                            )}
                          </div>
                        </div>
                      ) : (
                        <div className="message">
                          <div className="d-flex message-area">
                            <div className="no-data-img">
                              <img
                                src={noMessageIcon}
                                alt=""
                                className="no_message"
                              />
                            </div>
                            <div>
                              <h3 className="fw-bold display-6">
                                {' '}
                                <FormattedMessage id="no_holiday" />
                              </h3>
                              <h4 className="mb-3">
                                {formatMessage('no_holiday_message')}
                              </h4>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  ) : (
                    <CalendarView
                      selectedYear={year}
                      holidays={calendarHolidays}
                      weekends={weekendDays}
                      setSelectedDate={(date) => setSelectedDate(date)}
                      deleteHandler={calendarViewDeleteClickHandler}
                      language={language}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <SlidingPanel
        type={'right'}
        isOpen={openPanel}
        noBackdrop={false}
        size={100}
      >
        <div className="bg_slide panel">
          <div className="row bb p-2 pl-4 g-0 align-items-center ">
            <div className="col-lg-10 col-md-10 col-sm-10 col-xs-10">
              <h2 className="fw-bold mb-0 mt-1 ms-2 py-2">
                {selectedRow.HolidayName}
              </h2>
            </div>
            <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2 close-icon-detail">
              <span title={formatMessage('close')}>
                <CloseSidePanelIcon closePanelHandler={closePanelHandler} />
              </span>
            </div>
          </div>
          <div className="group_detailsWrapper pb-3">
            <FactoryScheduleDetails
              selectedRowId={selectedRow.HolidayId}
              row={selectedRow}
            />
          </div>
        </div>
      </SlidingPanel>
    </>
  );
};

export default DeleteAllFactorySchedulePopupHOC(
  ImportHolidayPopupHOC(
    AddHolidayCalendarPopupHOC(
      FilterPopupHOC(
        AddFactorySchedulePopupHOC(DeletePopupHOC(observer(FactorySchedule)))
      )
    )
  )
);
